import React, { FC } from 'react';
import { WeekComparisonMetric, formatComparisonChange } from '../log.helpers';

interface LogWeekComparisonProps {
  metrics: WeekComparisonMetric[];
}

const LogWeekComparison: FC<LogWeekComparisonProps> = ({ metrics }) => (
  <div className="log-week-status">
    {metrics.map((metric) => (
      <div key={metric.key} className="log-week-status-item">
        <div className={`log-ws-change ${metric.trend}`}>
          <span className="log-ws-arrow">
            {metric.direction === 'up' ? '↑' : metric.direction === 'down' ? '↓' : '—'}
          </span>{' '}
          {formatComparisonChange(metric)}
        </div>
        <div className="log-ws-label">{metric.label}</div>
        <div className="log-ws-value">{metric.currentDisplay}</div>
        <div className="log-ws-prev">{metric.previousDisplay}</div>
      </div>
    ))}
  </div>
);

export default LogWeekComparison;
